import { Box, FormControl, IconButton, Modal, Stack } from "@mui/material";
import { BootstrapInput } from "./components/bootStrapInput";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import StoreIcon from "@mui/icons-material/Store";
import StyledButton from "./../../../product/all-products/components/custom/StyledButton";
import {
  // AddedCustomerData,
  createB2CcustomerApi,
  SkipUserFun,
  addCustomer,
  getLoyaltyInfo,
} from "../../../../../config/Services";
import { useSnackbar } from "../../../product/hooks/SnackbarProvider";
import { memo, useContext, useEffect, useState } from "react";
import { emit } from "react-native-react-bridge/lib/web";
import { getMobilePos } from "../../../product/all-products/redux/Reducers/paginationReducer";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import { UserContext } from "../../../../../App";
import { useSelector } from "react-redux";
import useGetDevice from "../../../product/hooks/useGetDevice";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import {
  changePrevAddedTime,
  eventTrackerTime,
} from "../../../product/all-products/redux/Actions/eventTracker";
import { useDispatch } from "react-redux";
import {
  removeFromLocalStorage,
  setInLocalStorage,
} from "../../../../../utils/localStorageHelpers";
import CountryCodeInput from "./components/countryCodeInput";
import { countryOptions } from "./data/countries-details";
import { customEventTrigger } from "../../../../../analytics";
import LockResetIcon from "@mui/icons-material/LockReset";
import Swal from "sweetalert2";
import useAuthModal from "../../../product/hooks/useAuthModal";

const AddCustomerComponent = ({
  open,
  setOpen,
  cartItems,
  setCartItems,
  updateCustomerMobile,
  updateCustomerName,
  disableClose = false,
}) => {
  const [customerMobileNumber, setCustomerMobileNumber] = useState("");
  const { renderAuthModal, openAuthModal } = useAuthModal();
  const [whatsAppCheck, setWhatsAppCheck] = useState(false);
  const [skipModelLoader, setSkipModelLoader] = useState(false);
  const [customerMobile, setCustomerMobile] = useState(
    JSON.parse(localStorage.getItem("customer_details"))?.mobileNumber || ""
  );
  let retailUserLocalStorageData = JSON.parse(localStorage.getItem("retailUserDetails"));
  const licenseId = localStorage.getItem("licenseId");
  const sessionId = localStorage.getItem("sessionId");
  const orgId = localStorage.getItem("orgId");
  const locId = localStorage.getItem("locId");
  const cartId = localStorage.getItem("CartId");
  const showSnackbar = useSnackbar();
  const { setCartId, setCartTotalQty } = useContext(UserContext);
  const { subTotal, setSubTotal } = useContext(UserContext);
  const { total, setTotal } = useContext(UserContext);
  const { cgst, setCgst } = useContext(UserContext);
  const { sgst, setSgst, setSaleMode, saleMode, setCess } = useContext(UserContext);
  const [splitActive, setSplitActive] = useState(false);
  const [partialStatus, setPartailStatus] = useState(false);
  const isMobilePos = useSelector(getMobilePos);
  const [customerName, setCustomerName] = useState("");
  const [addModelLoader, setAddModelLoader] = useState(false);
  const { color } = useContext(UserContext);
  const isMobile = useGetDevice();
  const [adjustCheck, setAdjustCheck] = useState(false);
  const [customerSuccess, setCustomerSuccess] = useState(false);
  const dispatch = useDispatch();
  const licenseName = localStorage.getItem("licenseName");
  const [selectedCountry, setSelectedCountry] = useState({ label: "IN (+91)", value: "+91" });

  let retailPayload = {
    userName: null,
    userId: null,
    mobileNo: null,
    createdBy: retailUserLocalStorageData?.firstName,
    locationId: locId || "",
    sourceId: orgId || "",
    loggedInUser: retailUserLocalStorageData?.uidx,
    sourceLocationId: locId || "",
    sourceType: "RETAIL",
    sourceApp: saleMode === "delivery" ? "PALLET_RETAIL" : "PALLET_POS",
    destinationId: orgId || "",
    destinationLocationId: locId || "",
    destinationType: "RETAIL",
    comments: null,
    sessionId: sessionId || null,
    orderType: saleMode === "delivery" ? "B2C_ORDER" : "POS_ORDER",
    subOrderType: isMobile ? "MPOS_ORDER" : "POS_ORDER",
    licenseId: licenseId || null,
    hoId: null,
    channel: "POS",
    cartId: cartId || null,
    terminalName: licenseName || null,
  };

  const handleClose = () => {
    customEventTrigger("pos_skip_button");
    setSkipModelLoader(true);
    SkipUserFun(retailPayload)
      .then((res) => {
        const customer_details = {
          name: null,
          mobileNumber: null,
          uidx: null,
          whatsapp: false,
        };
        if (!cartItems.length) {
          const currentTime = new Date().getTime();
          dispatch(eventTrackerTime({ startTime: currentTime, startTimeAdded: true }));
          dispatch(changePrevAddedTime(currentTime));
          const orderMetricData = {
            startTime: currentTime,
            prevAddedProductTime: currentTime,
            startTimeAdded: true,
            manuallyAdded: 0,
            scannedProduct: 0,
            isMultipleBatch: false,
            avgProductAddTime: "",
            totalProducts: 0,
            productTimeArray: [],
            editOrderItem: 0,
            manuallyRemovedItems: 0,
            manualItemsGtin: [],
          };
          localStorage.setItem("orderMetricData", JSON.stringify(orderMetricData));
        }
        showSnackbar("Cart Added success", "success");
        setCartId(res?.data?.data?.cartId);
        setCartItems(res?.data?.data?.cartProducts || []);
        setCartTotalQty(res?.data?.data?.billing?.quantity);
        setCgst(res?.data?.data?.billing?.cgst);
        setSgst(res.data.data.billing.sgst);
        setCess(res.data.data.billing.totalCessAmount);
        setSubTotal(res.data.data.billing.totalCartValue);
        setTotal(res?.data?.data?.billing?.totalCartValue);
        setSkipModelLoader(false);
        setAdjustCheck(false);
        setOpen(false);
        setCustomerMobile("");
        setSplitActive(false);
        setPartailStatus(false);
        localStorage.setItem("CartId", res?.data?.data?.cartId);
        localStorage.setItem("sessionId", sessionId);
        localStorage.setItem("licenseId", licenseId);
        localStorage.setItem("customer_details", JSON.stringify(customer_details));
        updateCustomerMobile(customerMobileNumber);
        updateCustomerName(customerName);
        localStorage.removeItem("loyaltyDetails");
        isMobilePos &&
          emit({
            type: "localData",
            data: {
              CartId: res.data.data.cartId,
              customer_details: customer_details,
            },
          });
      })
      .catch((err) => {
        showSnackbar(err?.response?.data?.message || err?.message, "error");
      })
      .finally(() => {
        setSkipModelLoader(false);
      });
  };

  const addCustomerFun = () => {
    let addCustomerPayload = {
      mobile: customerMobileNumber,
      firstName: customerName,
      countryCode: removePlusSign(selectedCountry.value),
      tenantId: locId,
    };
    customEventTrigger("pos_customer_contact_added", {
      mobile_number: addCustomerPayload.mobile,
    });
    if (customerMobileNumber?.length !== 10 && selectedCountry.value == "+91") {
      showSnackbar("Enter a valid mobile number", "error");
    } else {
      setAddModelLoader(true);
      addCustomer(addCustomerPayload).then((response) => {
        let customerUidxData = {
          uidx: response?.data?.data?.uidx,
          phoneNumber: customerMobileNumber,
          name: customerName,
          organizationId: orgId,
          createdBy: retailUserLocalStorageData.uidx,
          locationId: locId,
          sessionId: sessionId,
          platform: "POS"
        };
        /*
        AddedCustomerData(customerUidxData)
        */
        createB2CcustomerApi(customerUidxData)
          .then((res) => {
            retailPayload.userName = customerName;
            retailPayload.mobileNo = customerMobileNumber;
            retailPayload.userId = customerUidxData?.uidx;
            // setCustomerName("Manesh");
            SkipUserFun(retailPayload)
              .then((res) => {
                const customer_details = {
                  name: response?.data?.data?.firstName,
                  mobileNumber: customerMobileNumber,
                  uidx: response?.data?.data?.uidx,
                  email: response?.data?.data?.email,
                  countryCode: response?.data?.data?.countryCode,
                  whatsapp: whatsAppCheck,
                };
                if (!cartItems.length) {
                  const currentTime = new Date().getTime();
                  dispatch(eventTrackerTime({ startTime: currentTime, startTimeAdded: true }));
                  dispatch(changePrevAddedTime(currentTime));
                  const orderMetricData = {
                    startTime: currentTime,
                    prevAddedProductTime: currentTime,
                    startTimeAdded: true,
                    manuallyAdded: 0,
                    scannedProduct: 0,
                    isMultipleBatch: false,
                    avgProductAddTime: "",
                    totalProducts: 0,
                    productTimeArray: [],
                    editOrderItem: 0,
                    manuallyRemovedItems: 0,
                    manualItemsGtin: [],
                  };
                  localStorage.setItem("orderMetricData", JSON.stringify(orderMetricData));
                }
                showSnackbar("Customer added success to cart", "success");
                setCartId(res?.data?.data?.cartId);
                setCartItems(res?.data?.data?.cartProducts);
                setCartTotalQty(res?.data?.data?.billing?.quantity);
                setCgst(res?.data?.data?.billing?.cgst);
                setSgst(res?.data?.data?.billing?.sgst);
                setCess(res.data.data.billing.totalCessAmount);
                setSubTotal(res?.data?.data?.billing?.totalCartValue);
                setTotal(res?.data?.data?.billing?.totalCartValue);
                retailPayload.userName = null;
                retailPayload.mobileNo = null;
                retailPayload.userId = null;
                localStorage.setItem("CartId", res.data.data.cartId);
                localStorage.setItem("customer_details", JSON.stringify(customer_details));
                updateCustomerMobile(customerMobileNumber);
                updateCustomerName(response?.data?.data?.firstName);
                isMobilePos &&
                  emit({
                    type: "localData",
                    data: {
                      CartId: res.data.data.cartId,
                      customer_details: customer_details,
                    },
                  });
                setCustomerMobile(customerMobileNumber);
                setCustomerSuccess(true);
                setCustomerName("");
                setCustomerMobileNumber("");
                setAdjustCheck(false);
                setAddModelLoader(false);
                setOpen(false);
                setSplitActive(false);
                setPartailStatus(false);
                const loyaltyPayload = {
                  customerType: "END_CUSTOMER",
                  customerId: customerUidxData?.uidx,
                  sourceOrgId: orgId,
                  platformSupportType: "B2C",
                };
                getLoyaltyInfo(loyaltyPayload).then((response) => {
                  const res = response?.data?.data?.data;
                  if (!res) {
                    removeFromLocalStorage("loyaltyDetails");
                  }
                  const loyaltyDetails = {
                    totalLoyalty: res.totalAvailablePoint,
                    totalLoyaltyValue: res.totalAvailablePointValue,
                  };
                  setInLocalStorage("loyaltyDetails", loyaltyDetails);
                });
              })
              .catch((err) => {
                showSnackbar(err?.response?.data?.message || err?.message, "error");
                setAddModelLoader(false);
              })
              .finally(() => {
                setAddModelLoader(false);
              });
          })
          .catch((err) => {
            showSnackbar(err?.response?.data?.message || err?.message, "error");
          })
          .finally(() => {
            setSkipModelLoader(false);
          });
      });
    }
  };
  const handleKeyPress = (e) => {
    if (!open) return;
    if (skipModelLoader || addModelLoader) return;
    if (e.key === "Enter") {
      if (customerMobileNumber !== "" || saleMode === "delivery") {
        addCustomerFun();
      } else {
        handleClose();
      }
    }
  };

  const handleOptionChange = (event) => {
    setSaleMode(event.target.value);
  };

  const toggleSaleMode = () => {
    if (saleMode == "in-store") {
      setSaleMode("delivery");
    } else {
      setSaleMode("in-store");
    }
  };

  const handleCountryChange = (selectedOption) => {
    setSelectedCountry(selectedOption);
  };

  // useEffect(() => {
  //     if (!open) return;
  //     const handleArrowKeyPress = (event) => {
  //         if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
  //             toggleSaleMode();
  //         } else if (event.key === 'ArrowDown') {
  //             toggleSaleMode();
  //         }
  //     };

  //     document.addEventListener('keydown', handleArrowKeyPress);

  //     return () => {
  //         document.removeEventListener('keydown', handleArrowKeyPress);
  //     };
  // }, [saleMode]);

  function removePlusSign(input) {
    if (typeof input !== "string") {
      return input;
    }
    if (input.startsWith("+")) {
      return input.slice(1);
    }
    return input;
  }

  const newSwal = Swal.mixin({
    customClass: {
      confirmButton: "button button-success",
      cancelButton: "button button-error",
      container: "close-session-swal-container",
    },
    buttonsStyling: false,
  });

  const clearLC = () => {
    newSwal
      .fire({
        title: "Are you sure you want to clear the local storage?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Proceed",
        cancelButtonText: "Cancel",
        backdrop: "rgba(0,0,0,0.4)",
      })
      .then((result) => {
        if (result.isConfirmed) {
          openAuthModal(() => {
            localStorage.clear();
            newSwal.fire({
              title: "Cleared!",
              text: "Local storage has been cleared.",
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
            });
          });
        }
      });
  };

  return (
    <div>
      <Modal open={open} onClose={disableClose ? undefined : () => setOpen(false)} disableEscapeKeyDown>
        <Box
          sx={{
            backgroundColor: color === "dark" ? "#353a50" : "#fff",
            color: color === "dark" ? "white" : "black",
            position: isMobile ? "static" : "fixed",
            top: "50%",
            left: "10%",
            maxWidth: isMobile ? "100%" : "40%",
            maxHeight: "100%",
            transform: isMobile ? "none" : "translate(50%, -50%)",
            width: isMobile ? "100%" : "50%",
            display: isMobile ? "flex" : "block",
            borderRadius: "10px",
            padding: "1.5rem",
            flexDirection: "column",
            justifyContent: "center",
            ...(isMobile && { height: "100%" }),
          }}
        >
          {renderAuthModal()}

          <IconButton
            onClick={() => {
              clearLC();
            }}
            sx={{
              position: "absolute",
              top: 10,
              right: 10,
              color: "#FF0000",
            }}
          >
            <LockResetIcon sx={{ fontSize: 28 }} />
          </IconButton>
          <h3 className="addCustomerText" style={{ marginBottom: "3vh" }}>
            Add Customer For The Orders
          </h3>

          <FormControl
            variant="standard"
            sx={{
              width: "100%",
            }}
          >
            <CountryCodeInput
              countryOptions={countryOptions}
              setCustomerMobileNumber={setCustomerMobileNumber}
              customerMobileNumber={customerMobileNumber}
              handleKeyPress={handleKeyPress}
              handleCountryChange={handleCountryChange}
              selectedCountry={selectedCountry}
            />
          </FormControl>
          <label htmlFor="checkbox">
            <div className="check-wrapper-box">
              <input
                type="checkbox"
                id="checkbox"
                checked={whatsAppCheck}
                onChange={(e) => {
                  setWhatsAppCheck(e.target.checked);
                }}
              />
              <WhatsAppIcon className="whats-app-logo" />
              <span className="restore-text">Get notification on whatsapp</span>
            </div>
          </label>
          <p style={{ fontSize: "0.7rem", color: "#6b7280", margin: "4px 0 8px", lineHeight: 1.4 }}>
            Sending WhatsApp notifications requires a WhatsApp API integration.{" "}
            Connect your own number, or subscribe to a{" "}
            <strong style={{ fontWeight: 600 }}>Pallet Notifications plan</strong>{" "}
            to send messages via a Pallet-managed number.
          </p>
          <FormControl
            variant="standard"
            sx={{
              width: "100%",
              marginTop: "1rem",
            }}
          >
            <BootstrapInput
              placeholder="Enter Name"
              id="bootstrap-input"
              value={customerName}
              onChange={(e) => setCustomerName(e.target.value)}
              onKeyDown={handleKeyPress}
            />
          </FormControl>

          <div className="check-wrapper-box">
            <input
              type="radio"
              name="check"
              value="in-store"
              checked={saleMode === "in-store"}
              onChange={handleOptionChange}
            />
            <LocalShippingIcon className="whats-app-logo-I" />
            <span className="restore-text">In-store</span>
            <input
              type="radio"
              name="check"
              value="delivery"
              checked={saleMode === "delivery"}
              onChange={handleOptionChange}
              disabled
            />
            <StoreIcon className="whats-app-logo-I" />
            <span className="del-text">Delivery</span>
          </div>
          <div className="skipBtnContainer">
            <Stack direction="column" spacing={2}>
              <div className="btn-container">
                <StyledButton
                  onClick={handleClose}
                  loading={skipModelLoader}
                  color="gray"
                  disabled={saleMode === "in-store" ? false : true}
                >
                  <p>Skip</p> <KeyboardArrowRightIcon fontSize="small" />
                </StyledButton>

                <StyledButton
                  onClick={addCustomerFun}
                  loading={addModelLoader}
                  disabled={
                    customerMobileNumber?.length === 10 ||
                    (selectedCountry?.value !== "+91" && customerMobileNumber?.length >= 4)
                      ? false
                      : true
                  }
                >
                  <p>Add</p> <ControlPointIcon fontSize="small" />
                </StyledButton>
              </div>
            </Stack>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default memo(AddCustomerComponent);
